import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'search-control',
  standalone: false,
  templateUrl: './search-control.component.html',
  styleUrl: './search-control.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SearchControlComponent),
      multi: true
    }
  ]
})
export class SearchControlComponent implements ControlValueAccessor {
  @Input() placeholder = 'Search';

  searchTerm = '';

  clearSearch(): void {
    this.searchTerm = '';
    this.ngOnChange('');
  }
  
  // ControlValueAccessor implementation
  ngOnChange: (val: string) => void;

  registerOnChange(fn: any): void {
    this.ngOnChange = fn;
  }

  registerOnTouched(fn: any): void {
    // nothing to do on touched
  }

  writeValue(value: string): void {
    this.searchTerm = value ?? '';
  }

}
